<script setup>
import { CpuChipIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n.js'
import { nextTick, ref, watch } from 'vue'

const { t } = useI18n()

const props = defineProps({
  controllers: { type: Array, default: () => [] },
  activeControllerId: { type: Number, default: null },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  unavailableLabel: { type: String, default: '' },
  accessibleLabel: { type: String, default: '' },
})
const emit = defineEmits(['select'])
const selectElement = ref(null)
let restoreFocus = false

watch(() => props.disabled, async (disabled) => {
  if (disabled) {
    restoreFocus = document.activeElement === selectElement.value
    return
  }
  if (!restoreFocus) return
  restoreFocus = false
  await nextTick()
  if (document.activeElement === document.body && selectElement.value && !selectElement.value.disabled) selectElement.value.focus()
}, { flush: 'sync' })

function select(event) {
  const controllerId = Number(event.target.value)
  if (controllerId) emit('select', controllerId)
}
</script>

<template>
  <label class="pts2-controller-selector">
    <CpuChipIcon aria-hidden="true" />
    <span class="pts2-context-copy">
      <small>{{ label || t('pts2UiController') }}</small>
      <select ref="selectElement" :value="activeControllerId ?? ''" :disabled="disabled || !controllers.length"
        :aria-label="accessibleLabel || t('pts2UiControllerAccessible')" @change="select">
        <option value="" disabled>{{ controllers.length ? (placeholder || t('pts2UiChoose')) : (unavailableLabel || t('pts2UiControllersUnavailable')) }}</option>
        <option v-for="controller in controllers" :key="controller.id" :value="controller.id">
          {{ controller.stableCode || controller.displayName }}
        </option>
      </select>
    </span>
  </label>
</template>

<style scoped>
select:focus-visible { outline: 3px solid #26899a; outline-offset: 3px; }
</style>
